
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Technology from './components/Technology';
import WhyUs from './components/WhyUs';
import Applications from './components/Applications';
import About from './components/About';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Technology />
      <WhyUs />
      <Applications />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
